import { useEffect, useState } from "react";
import { useCountry } from "@hooks/useCountry";
import Cookies from "js-cookie";

/** Hook to determine if user preferred SG edition or NONSG edition or ZH edition. */
export const usePreferredEdition = () => {
  const { isSGUser } = useCountry();
  const [edition, setEdition] = useState<string>();

  const handleSG = () => {
    if (typeof window === "undefined") return;

    Cookies.set("preferred_region", "SG");
  };

  const handleNONSG = () => {
    if (typeof window === "undefined") return;

    Cookies.set("preferred_region", "NONSG");
  };

  useEffect(() => {
    if (typeof window === "undefined") return;

    const userPreferredVersion = Cookies.get("preferred_region");

    if (typeof userPreferredVersion !== "undefined") {
      setEdition(userPreferredVersion);
      return;
    }

    if (isSGUser) setEdition("SG");
    else setEdition("NONSG");
  }, [isSGUser]);

  return { edition, handleSG, handleNONSG };
};
